import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import api, { resolveImage } from "@/lib/api";

export const BlogPreview = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data.slice(0, 3))).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="journal" className="py-24 lg:py-32 border-t border-forest/15" data-testid="journal-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <span className="text-xs font-bold tracking-[0.3em] uppercase text-terra">The Journal</span>
            <h2 className="font-serif font-bold tracking-tighter text-forest text-4xl sm:text-5xl lg:text-6xl mt-4" data-testid="journal-heading">
              Stories from the <span className="italic text-terra">field.</span>
            </h2>
          </motion.div>
          <Link
            to="/blog"
            data-testid="journal-view-all-link"
            className="group flex items-center gap-2 text-sm font-bold text-forest hover:text-terra transition-colors"
          >
            Read all stories
            <ArrowUpRight size={18} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="group border border-forest/20 bg-bone hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300"
              data-testid={`journal-card-${p.slug}`}
            >
              <Link to={`/blog/${p.slug}`} className="block">
                {p.cover_image && (
                  <div className="overflow-hidden border-b border-forest/20">
                    <img
                      src={resolveImage(p.cover_image)}
                      alt={p.title}
                      className="w-full h-52 object-cover img-warm transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                )}
                <div className="p-6">
                  <span className="text-[10px] font-bold tracking-[0.25em] uppercase text-terra">
                    {new Date(p.created_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                  </span>
                  <h3 className="font-serif font-bold text-xl text-forest tracking-tight mt-2 leading-snug">{p.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-moss line-clamp-3">{p.excerpt}</p>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
